import { Slot } from '@radix-ui/react-slot';

interface DialogTriggerProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  asChild?: boolean;
}

export function DialogTrigger({ children, asChild, ...props }: DialogTriggerProps) {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp type="button" data-slot="dialog-trigger" {...props}>
      {children}
    </Comp>
  );
}
